import { useQuery } from 'react-query';
import { OrganizationEntity } from 'src/core/types';

import axios from './axios';

export interface UseDepartmentsProps {}

export function useDepartments(props: UseDepartmentsProps = {}) {
  return useQuery<OrganizationEntity[]>(
    'departments',
    async () => {
      return axios
        .get<OrganizationEntity[]>('/posht/ashena/departments/')
        .then((res) => res.data);
    },
    {
      suspense: false,
    },
  );
}
